import { sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import ProsumerHome from "app/components/prosumer_home"
import FeaturedAppletsModule from "app/components/featured_applets_module"
import StorySpotlight from "app/components/story_spotlight"
import { PromptHero } from "app/components/prompt_hero"
import McpAgentShowcase from "app/scripts/mcp_agent_showcase"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import SetupAccountMenu from "shared/scripts/setup_account_menu"
import "app/components/prosumer/homepage_module_animation"
import "app/components/prosumer/how_it_works_animation"
import "app/scripts/track_component_impression"

// Shared by the customer and customer_marketing entrypoints, which differ only in stylesheet.
export default function setupCustomerBundle() {
  sharedVanillaSetup()

  Object.assign(window.App.Scripts, {
    SetupUnifiedMobileMenu,
    SetupAccountMenu,
    ProsumerHome,
    PromptHero,
    FeaturedAppletsModule,
    StorySpotlight,
    McpAgentShowcase,
  })
}
